"use client";
import React, { useState } from "react";
import styles from "../styles/Footer.module.css";
import Logo from "../images/logoo.png";


const Footer = () => {
  const [currentYear] = useState(() => new Date().getFullYear());

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          <div className={styles.footerGrid}>
            <div className={styles.brandSection}>
              <img
                src={Logo}
                alt="Company Logo"
                className={styles.brandLogo}
                loading="lazy"
              />
              <p className={styles.brandDescription}>
                Transforming ideas into powerful digital solutions since 2023.
              </p>
            </div>

            <div className={styles.linkSection}>
              <h3 className={styles.sectionTitle}>Services</h3>
              <div className={styles.linkList}>
                <a href="/services" className={styles.footerLink}>
                  Web Development
                </a>
                <a href="/services" className={styles.footerLink}>
                  Mobile Development
                </a>
                <a href="/services" className={styles.footerLink}>
                  UI/UX Design
                </a>
                <a href="/services" className={styles.footerLink}>
                  Cloud Solutions
                </a>
                <a href="/services" className={styles.footerLink}>
                  Digital Strategy
                </a>
                <a href="/services" className={styles.footerLink}>
                  E-commerce
                </a>
              </div>
            </div>

            <div className={styles.linkSection}>
              <h3 className={styles.sectionTitle}>Quick Links</h3>
              <div className={styles.linkList}>
                <a href="/" className={styles.footerLink}>
                  Home
                </a>
                <a href="/services" className={styles.footerLink}>
                  Our Services
                </a>
                <a href="/contact" className={styles.footerLink}>
                  Contact
                </a>
                <a href="/portfolio" className={styles.footerLink}>
                  Portfolio
                </a>
                
              </div>
            </div>

            <div className={styles.linkSection}>
              <h3 className={styles.sectionTitle}>Connect</h3>
              <div className={styles.linkList}>

                <a href="https://www.instagram.com/vionexlabs/" className={styles.footerLink}>
                  Instagram
                </a>
              
              </div>
            </div>

            {/* <div className={styles.linkSection}>
              <h3 className={styles.sectionTitle}>Legal</h3>
              <div className={styles.linkList}>
                <a href="/privacy-policy" className={styles.footerLink}>
                  Privacy Policy
                </a>
                <a href="/terms-of-service" className={styles.footerLink}>
                  Terms of Service
                </a>
                <a href="/cookie-policy" className={styles.footerLink}>
                  Cookie Policy
                </a>
              </div>
            </div> */}
          </div>

          <div className={styles.footerBottom}>
            <div className={styles.bottomBorder}>
              <div className={styles.contactSection}>
                <div className={styles.contactInfo}>
                  <div className={styles.contactDetails}>
                    <div className={styles.contactItem}>
                      <div className={styles.contactIcon}>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10Z"
                            stroke="#182CD4"
                            strokeWidth="2"
                          />
                          <path
                            d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                            stroke="#182CD4"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span className={styles.contactText}>
                        Raipur, Chhattisgarh
                      </span>
                    </div>

                    <div className={styles.contactItem}>
                      <div className={styles.contactIcon}>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.0004 16.9201V19.9201C22.0015 20.1986 21.9445 20.4743 21.8329 20.7294C21.7213 20.9846 21.5577 21.2137 21.3525 21.402C21.1472 21.5902 20.905 21.7336 20.6411 21.8228C20.3773 21.912 20.0978 21.9452 19.8204 21.9201C16.7432 21.5857 13.7874 20.5342 11.1904 18.8501C8.77425 17.3148 6.72576 15.2663 5.19042 12.8501C3.5004 10.2413 2.44867 7.27109 2.12042 4.1801C2.09543 3.90357 2.1283 3.62486 2.21692 3.36172C2.30555 3.09859 2.44799 2.85679 2.63519 2.65172C2.82239 2.44665 3.05023 2.28281 3.30422 2.17062C3.5582 2.05843 3.83276 2.00036 4.11042 2.0001H7.11042C7.59574 1.99532 8.06622 2.16718 8.43419 2.48363C8.80216 2.80009 9.0425 3.23955 9.11042 3.7201C9.23705 4.68017 9.47187 5.62283 9.81042 6.5301C9.94497 6.88802 9.97409 7.27701 9.89433 7.65098C9.81458 8.02495 9.62929 8.36821 9.36042 8.6401L8.09042 9.9101C9.51398 12.4136 11.5869 14.4865 14.0904 15.9101L15.3604 14.6401C15.6323 14.3712 15.9755 14.1859 16.3495 14.1062C16.7235 14.0264 17.1125 14.0556 17.4704 14.1901C18.3777 14.5287 19.3203 14.7635 20.2804 14.8901C20.7662 14.9586 21.2098 15.2033 21.5269 15.5776C21.8441 15.9519 22.0126 16.4297 21.1004 16.9201H22.0004Z"
                            stroke="#182CD4"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span className={styles.contactText}>
                        +91 7725 008610
                      </span>
                    </div>
                    <div className={styles.contactItem}>
                    <div className={styles.contactIcon}>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.0004 16.9201V19.9201C22.0015 20.1986 21.9445 20.4743 21.8329 20.7294C21.7213 20.9846 21.5577 21.2137 21.3525 21.402C21.1472 21.5902 20.905 21.7336 20.6411 21.8228C20.3773 21.912 20.0978 21.9452 19.8204 21.9201C16.7432 21.5857 13.7874 20.5342 11.1904 18.8501C8.77425 17.3148 6.72576 15.2663 5.19042 12.8501C3.5004 10.2413 2.44867 7.27109 2.12042 4.1801C2.09543 3.90357 2.1283 3.62486 2.21692 3.36172C2.30555 3.09859 2.44799 2.85679 2.63519 2.65172C2.82239 2.44665 3.05023 2.28281 3.30422 2.17062C3.5582 2.05843 3.83276 2.00036 4.11042 2.0001H7.11042C7.59574 1.99532 8.06622 2.16718 8.43419 2.48363C8.80216 2.80009 9.0425 3.23955 9.11042 3.7201C9.23705 4.68017 9.47187 5.62283 9.81042 6.5301C9.94497 6.88802 9.97409 7.27701 9.89433 7.65098C9.81458 8.02495 9.62929 8.36821 9.36042 8.6401L8.09042 9.9101C9.51398 12.4136 11.5869 14.4865 14.0904 15.9101L15.3604 14.6401C15.6323 14.3712 15.9755 14.1859 16.3495 14.1062C16.7235 14.0264 17.1125 14.0556 17.4704 14.1901C18.3777 14.5287 19.3203 14.7635 20.2804 14.8901C20.7662 14.9586 21.2098 15.2033 21.5269 15.5776C21.8441 15.9519 22.0126 16.4297 21.1004 16.9201H22.0004Z"
                            stroke="#182CD4"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                     <span className={styles.contactText}>
                        +91 6265 865507
                      </span>
                    </div>
                      

                    <div className={styles.contactItem}>
                      <div className={styles.contactIcon}>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                            stroke="#182CD4"
                            strokeWidth="2"
                          />
                          <path
                            d="M22 6L12 13L2 6"
                            stroke="#182CD4"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span className={styles.contactText}>
                        support@vionexlabs.com
                      </span>
                    </div>
                  </div>
                </div>

                {/* <div className={styles.socialIcons}>
                  <a href="#" className={styles.socialIcon}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"
                        stroke="#182CD4"
                        strokeWidth="2"
                      />
                    </svg>
                  </a>

                  <a href="#" className={styles.socialIcon}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                        fill="#182CD4"
                      />
                      <circle cx="4" cy="4" r="2" fill="#182CD4" />
                    </svg>
                  </a>

                  <a href="#" className={styles.socialIcon}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"
                        stroke="#182CD4"
                        strokeWidth="2"
                      />
                    </svg>
                  </a>

                  <a href="#" className={styles.socialIcon}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="#182CD4"
                        strokeWidth="2"
                      />
                      <path
                        d="M12 1a11 11 0 00-11 11 11 11 0 0011 11 11 11 0 0011-11A11 11 0 0012 1z"
                        stroke="#182CD4"
                        strokeWidth="2"
                      />
                      <path
                        d="M18.5 6.5L12 12l-6.5-5.5"
                        stroke="#182CD4"
                        strokeWidth="2"
                      />
                    </svg>
                  </a>
                </div> */}
              </div>

              <div className={styles.legalSection}>
                <div className={styles.legalBorder}>
                  <div className={styles.legalContent}>
                    <div className={styles.legalLinks}>
                      <p className={styles.copyrightText}>
                        © {currentYear} Vionex Labs. All rights reserved.
                      </p>
                      <div className={styles.policyLinks}>
                        <a href="/privacy-policy" className={styles.policyLink}>
                          Privacy Policy
                        </a>
                        <a href="/privacy-policy" className={styles.policyLink}>
                          Terms of Service
                        </a>
                        <a href="/privacy-policy" className={styles.policyLink}>
                          Cookie Policy
                        </a>
                      </div>
                    </div>

                    <div className={styles.madeWith}>
                      <span className={styles.madeWithText}>Made with</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
                          fill="#FF6B6B"
                        />
                      </svg>
                      <span className={styles.madeWithText}>by our team</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
